module.exports = __webpack_public_path__ + "36c5eaff021464e421a086e208a81c5d.png";